<template>
	<v-timeline dense v-if="stat.reportingRequestStartTime" class="job-timeline">
		<v-timeline-item hide-dot class="title">Report</v-timeline-item>
		<v-timeline-item small v-if="stat.reportingRequestStartTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(created)}}</v-col>
				<v-col cols="3" class="event">Queued</v-col>
				<v-col cols="4" class="code"><strong><span v-html="timeDuration(created, stat.reportingRequestStartTime)" /> QUEUE WAIT</strong></v-col>
			</v-row>
		</v-timeline-item>
		<v-timeline-item small v-if="stat.downloadToProcessorStartTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(stat.reportingRequestStartTime)}}</v-col>
				<v-col cols="3" class="event">Job Start</v-col>
				<v-col cols="4" class="code"><span v-html="timeDuration(stat.reportingRequestStartTime, stat.reportingRequestEndTime)" /> JOB TOTAL</v-col>
			</v-row>
		</v-timeline-item>
		<v-timeline-item small v-if="stat.reportingRehydrateAnalysisStartTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(stat.reportingRehydrateAnalysisStartTime)}}</v-col>
				<v-col cols="3" class="event">Rehydrate Analysis</v-col>
				<v-col cols="3" class="code" v-html="timeDuration(stat.reportingRehydrateAnalysisStartTime, stat.reportingRehydrateAnalysisEndTime)" />
			</v-row>
		</v-timeline-item>
		<v-timeline-item small v-if="stat.reportingRebuildSignalsStartTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(stat.reportingRebuildSignalsStartTime)}}</v-col>
				<v-col cols="3" class="event">Rebuild Signals</v-col>
				<v-col cols="3" class="code" v-html="timeDuration(stat.reportingRebuildSignalsStartTime, stat.reportingRebuildSignalsEndTime)" />
			</v-row>
		</v-timeline-item>
		<v-timeline-item small v-if="stat.reportGenetationStartTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(stat.reportGenetationStartTime)}}</v-col>
				<v-col cols="3" class="event">Generation</v-col>
				<v-col cols="3" class="code" v-html="timeDuration(stat.reportGenetationStartTime, stat.reportGenerationEndTime)" />
			</v-row>
		</v-timeline-item>
		<v-timeline-item small v-if="stat.reportingResultsUploadStartTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(stat.reportingResultsUploadStartTime)}}</v-col>
				<v-col cols="3" class="event">Report Upload</v-col>
				<v-col cols="3" class="code" v-html="timeDuration(stat.reportingResultsUploadStartTime, stat.reportingResultsUploadEndTime)" />
			</v-row>
		</v-timeline-item>
		<v-timeline-item small v-if="stat.reportingRequestEndTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(stat.reportingRequestEndTime)}}</v-col>
				<v-col cols="3" class="event">Job End</v-col>
				<v-col cols="4" class="code"></v-col>
			</v-row>
		</v-timeline-item>
	</v-timeline>
</template>

<script>
export default {
	props: {
		stat: Object,
		created: String,
	},
	data() {
		return {};
	},
	methods: {
	},
};
</script>
